// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?ver=" + "da372727b2e6404dfc4d" + "";
};